<script setup lang="ts">
import { computed } from "vue";

interface IProps {
  sectionParentsPath: Array<string>;
  sectionName?: string;
}

const props = defineProps<IProps>();

const sectionFullPath = computed(() => {
  if (!props.sectionName) return [];

  return [...props.sectionParentsPath, props.sectionName];
});
</script>

<template>
  <div class="section-parents-path">
    <template
      v-for="(sectionName, index) in sectionFullPath"
      :key="index"
    >
      <span>{{ sectionName }}</span>
      <i
        v-if="index < sectionFullPath.length - 1"
        class="pi pi-angle-right text-xs"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.section-parents-path {
  @apply flex flex-row gap-2 text-gray-500 items-center;
}
</style>
